<template>
	<claim-list scene="approve"></claim-list>
</template>

<script>
	import claimList from '../claim/claim_list'
	
	export default {
		components: {
			claimList
		}
	}
</script>
